import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { skuListAndConfig } from 'src/helper/static';
import { environment } from 'src/environments/environment';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { Observable, SubscriptionLike, max } from 'rxjs';
import { CONFIG, CoolerType } from 'src/helper/app-config';
import { reviewSkuModal } from 'src/modals/planogram';
import { Router, ActivatedRoute } from '@angular/router';
import {
  CdkDragDrop,
  CdkDropList,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogModalComponent } from '../confirm-dialog-modal/confirm-dialog-modal.component';
import * as htmlToImage from 'html-to-image';
import { PlanogramService } from 'src/services/planogram.service';
@Component({
  selector: 'app-planogram-new-component',
  templateUrl: './planogram-new-component.component.html',
  styleUrl: './planogram-new-component.component.css',
})
export class PlanogramNewComponentComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() drop_item_ids: string[] = [];
  @Input() reset: boolean = false;
  @Input() placed_sku_list: reviewSkuModal = {};
  @Input() planogram_details: any;
  @Input() save: boolean = false;
  @Output() newDropItemIdEvent = new EventEmitter<{
    id: string;
    row_no: number;
    position: number;
  }>();
  isReset = true;
  planogram_id: number;
  sku_list = skuListAndConfig.facings;
  NoOfShelves: { [key: string]: number } = {};
  current_drag_element_id: any;
  current_dragged_element: any;
  review_sku_list_subscription: SubscriptionLike;
  reviewSkuListObservable: Observable<any> =
    this.planogramState.review_sku_list;
  review_sku_list: reviewSkuModal;
  No_Of_Cooler: any[];
  CONFIG = CONFIG;
  dropped_items: any;
  coolerShelfWidth: any = {};
  maxHeightsOfShelves: any = {};
  review_lhs_sku_list_subscription: SubscriptionLike;
  review_lhs_sku_list_observable: Observable<any> =
    this.planogramState.review_lhs_sku_list;
  planogram_loader: Observable<boolean> = this.planogramState.planogram_loader;
  review_screen_sku_image_list_observable: Observable<any> =
    this.planogramState.review_screen_sku_images;
  review_screen_sku_image_list_subscription: SubscriptionLike;
  review_screen_sku_image_list: any;
  review_lhs_sku_list: any;
  local_reset: boolean = false;
  planogram_cooler_specific_sku_images: any = {};
  constructor(
    private planogramState: PlanogramStateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private apiService: PlanogramService
  ) {
    this.activatedRoute.params.subscribe((params) => {
      let planogram_id = params['planogram_id'];
      if (planogram_id) {
        this.planogram_id = planogram_id;
        this.planogramState.fetchReviewSkuFacings({
          planogram_id: planogram_id,
        });
      }
    });
  }

  ngOnInit(): void {
    this.review_screen_sku_image_list_subscription=this.review_screen_sku_image_list_observable.subscribe(
      (res)=>{
        this.review_screen_sku_image_list=res
      }
    )
    this.review_sku_list_subscription = this.reviewSkuListObservable.subscribe(
      (res) => {
        console.log('reviewSkuListObservable', res);
        if (res.facings_data) {
          this.review_sku_list = res.facings_data;
          this.placed_sku_list = res.facings_data;
          this.No_Of_Cooler = Object.keys(res.facings_data);
          this.No_Of_Cooler.forEach((cooler: any) => {
            console.log(
              'res.data final facings',
              this.review_sku_list[cooler].facings.map(
                (v: any) => v.final_facings
              )
            );
          });
          this.calculateNoOfShelves(res.facings_data);
          this.setEmptyPlaceholderWhenSkusAreNOtEqualToMax(res.facings_data);
        }
      }
    );
    this.review_lhs_sku_list_subscription =
      this.review_lhs_sku_list_observable.subscribe((res) => {
        if (res) {
          this.review_lhs_sku_list = res;
        }
      });
  }

  ngOnDestroy(): void {
    this.review_sku_list_subscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reset'] && this.reset == true && this.save !== true) {
      let keys = Object.keys(this.review_sku_list);
      this.placed_sku_list = {};
      for (let cooler of keys) {
        let shelves_data = this.review_sku_list[cooler].shelves;
        let shelves_length = shelves_data.length;
        this.placed_sku_list[cooler] = {
          facings: [],
          shelves: shelves_data,
          dimensions: { height: '', width: '' },
        };
        // let placement_order_count=1
        // for (let i = 0; i < shelves_length; i++) {
        //   let max_limit = shelves_data[i].max_limit;
        //   let shelf_number = shelves_data[i].shelf_number;
        //   let shelf_type = shelves_data[i].shelf;
        //   for (let j = 0; j < max_limit; j++) {
        //     let sku_placeholder = {
        //       brand_inswa: "",
        //       category: "",
        //       cooler: cooler,
        //       diameter_mm: shelves_data[i].avg_diameter,
        //       final_facings: 0,
        //       height_mm: shelves_data[i].avg_height,
        //       max_limit: max_limit,
        //       mrp:0,
        //       pack_size_revised:0,
        //       pack_type_revised:"",
        //       placement_order: placement_order_count,
        //       ranking:0,
        //       sku_face: "",
        //       sku_image_uri:"",
        //       shelf_number: shelf_number,
        //       shelf: shelf_type,
        //       placeholder: true,
        //     };
        //     placement_order_count++
        //     this.placed_sku_list[cooler].facings.push(sku_placeholder);
        //   }
        // }
        let facings = this.review_sku_list[cooler].facings.slice();
        facings.forEach((sku, i) => {
          if (sku.final_facings > 1) {
            let temp_sku = sku;
            let sku_array = [];
            let final_facings = sku.final_facings;
            temp_sku.final_facings = 1;
            for (let j = 0; j < final_facings; j++) {
              sku_array.push(temp_sku);
            }
            facings.splice(i, 1, ...sku_array);
          }
        });
        this.placed_sku_list[cooler].facings = facings;
      }
    }
    // if (changes['save'] && this.save == true) {
    //   this.reset = false;
    //   this.planogramState.saveCustomPlanogram(this.planogram_details.cooler, {
    //     id: this.planogram_id,
    //     data: { facings_data: this.placed_sku_list },
    //   });
    // }
  }

  checkIfEmptyPlanogram() {
    let coolers = Object.keys(this.placed_sku_list);
    let empty = true;
    for (let i = 0; i < coolers.length; i++) {
      let facings = this.placed_sku_list[coolers[i]]['facings'];
      facings.forEach((sku: any) => {
        if (sku.final_facings !== 0) {
          empty = false;
        }
      });
    }
    return empty;
  }

  saveCustomizedPlanogram() {
    let isEmpty = this.checkIfEmptyPlanogram();
    if (isEmpty) {
      const dialogRef = this.dialog.open(ConfirmDialogModalComponent, {
        width: '500px',
        data: {
          header_msg: 'Error',
          header_msg_description: 'Cant create empty plano',
          ok_action: 'Ok',
        },
      });
    } else {
      this.local_reset = true;
      let coolers = Object.keys(this.placed_sku_list);
      for (let i = 0; i < coolers.length; i++) {
        this.placed_sku_list[coolers[i]].facings.map(
          (facing) => delete facing.blob_img_uri
        );
      }
      console.log('this.placed_sku_list==========>', this.placed_sku_list);
      this.planogramState.saveCustomPlanogram(this.planogram_details.cooler, {
        id: this.planogram_id,
        data: { facings_data: this.placed_sku_list },
      });
    }
  }

  dropped(
    event: any,
    shelf_number: number,
    position: number,
    shelf_type: string,
    max_limit: number,
    cooler: string,
    sku_present_data: any,
    facing_index: number
  ) {
    let data = { ...event.item.data };
    let shelfType: string[] = [];
    let max_allowed = 0;
    this.review_sku_list[cooler].shelves.forEach((shelf) => {
      if (shelf.shelf_number == shelf_number) {
        shelfType.push(shelf.shelf);
        max_allowed = max_allowed + shelf.max_limit;
      }
    });
    if (event.isPointerOverContainer && position < max_allowed) {
      if (shelfType.includes(data.shelf_type)) {
        let sku_data = {
          brand_inswa: data.brand_inswa,
          category: data.category,
          cooler: cooler,
          diameter_mm: data.diameter,
          final_facings: 1,
          height_mm: data.height,
          max_limit: max_limit,
          mrp: data.mrp,
          pack_size_revised: data.pack_size_revised,
          pack_type_revised: data.pack_type_revised,
          placement_order: 0,
          ranking: 0,
          shelf: data.shelf_type,
          shelf_number: shelf_number,
          sku_face: data.sku_face,
          sku_image_uri: data.sku_image_uri,
          blob_img_uri: data.blob_img_uri,
          facings_multiplier: data.facings_multiplier,
        };
        let temp_place_holder_sku_list =
          this.placed_sku_list[cooler].facings.slice();
        let positionOfSku =
          temp_place_holder_sku_list.findIndex(
            (shelf) => shelf.shelf_number === shelf_number
          ) + position;
        sku_data.placement_order = positionOfSku + 1;

        this.placed_sku_list[cooler].facings[positionOfSku] = sku_data;
      } else {
        this.dialog.open(ConfirmDialogModalComponent, {
          height: '200px',
          width: '500px',
          data: {
            header_msg: 'Error',
            header_msg_description: `The sku selected(${
              data.shelf_type
            }) can not be placed in this shelf(${shelfType.join(',')})`,
            ok_action: 'Ok',
          },
        });
      }
    }
  }

  setEmptyPlaceholderWhenSkusAreNOtEqualToMax(skuList: any) {
    for (const cooler of this.No_Of_Cooler) {
      const facings_data = skuList[cooler].facings;
      const shelves = skuList[cooler].shelves;
      const filteredShelves = shelves.filter(
        (shelf: any, i: any) =>
          i ===
          shelves.findIndex((s: any) => s.shelf_number === shelf.shelf_number)
      );
      const coolerHeightInNumber = parseFloat(
        this.review_sku_list[cooler]['dimensions']['height']
          .replace('mm', '')
          .trim()
      );
      let calculatedMaxHeightOfCooler = 0;
      this.maxHeightsOfShelves[cooler] ||= [];

      filteredShelves.forEach((shelf: any, i: number) => {
        const facings_data_for_the_shelf = facings_data.filter(
          (sku: any) => sku.shelf_number === shelf.shelf_number
        );
        const lastIndexForShelf = facings_data_for_the_shelf.length - 1;

        const { sku_count, max_height } = facings_data_for_the_shelf.reduce(
          (acc: any, sku: any) => {
            acc.sku_count += sku.final_facings;
            acc.max_height = Math.max(acc.max_height, sku.height_mm);
            return acc;
          },
          { sku_count: 0, max_height: 0 }
        );

        calculatedMaxHeightOfCooler += max_height;

        this.maxHeightsOfShelves[cooler][i] = { max_height };

        if (sku_count !== shelf.max_limit) {
          const empty_sku_data = {
            brand_inswa: '',
            category: '',
            cooler,
            diameter_mm: shelf.avg_diameter,
            final_facings: 0,
            height_mm: shelf.avg_height,
            max_limit: shelf.max_limit,
            mrp: 0,
            pack_size_revised: 0,
            pack_type_revised: '',
            placement_order: 0,
            ranking: 0,
            sku_face: '',
            sku_image_uri: '',
            shelf_number: shelf.shelf_number,
            shelf: shelf.shelf,
            facings_multiplier: 0,
            blob_img_uri: '',
          };
          const length = shelf.max_limit - sku_count;
          const empty_skus =
            length > 0 ? Array(length).fill(empty_sku_data) : [];

          this.review_sku_list[cooler].facings.splice(
            lastIndexForShelf + 1,
            0,
            ...empty_skus
          );
        }
      });

      this.maxHeightsOfShelves[cooler].forEach((shelf: any, i: number) => {
        shelf.max_height =
          coolerHeightInNumber /
          (calculatedMaxHeightOfCooler / shelf.max_height);
      });
    }
  }

  calculateNoOfShelves(skuList: any[]) {
    for (let cooler of this.No_Of_Cooler) {
      let facings_data = skuList[cooler].shelves;
      let shelves = facings_data.filter(
        (shelf: any, i: any) =>
          i ==
          facings_data.findIndex(
            (s: any) => s.shelf_number == shelf.shelf_number
          )
      );

      //this.getImages(cooler, this.review_sku_list[cooler].facings);

      this.NoOfShelves[cooler] = shelves.length;
      this.coolerShelfWidth[cooler] = Number(
        this.review_sku_list[cooler].dimensions.width.replace('mm', '')
      );
    }

    // let tempShelfNo = 0;
    // let tempNoOfSelf = [];
    // for (let sku of skuList) {
    //   if (sku.shelf_number !== tempShelfNo) {
    //     tempShelfNo = sku.shelf_number;
    //     tempNoOfSelf.push(sku.shelf_number);
    //   }
    // }
    // this.NoOfShelves = tempNoOfSelf;
    // console.log('number of shelves', this.NoOfShelves);
  }

  findShelfInSkuList(shelf: number, cooler: string) {
    if (this.reset) {
      return (
        this.placed_sku_list[cooler].facings
          // .map((sku, i) => {
          //   sku.blob_img_uri =
          //     this.planogram_cooler_specific_sku_images[cooler][i];
          //   return sku;
          // })
          .filter((sku) => sku.shelf_number == shelf)
      );
    } else {
      return (
        this.review_sku_list[cooler].facings
          // .map((sku, i) => {
          //   sku.blob_img_uri =
          //     this.planogram_cooler_specific_sku_images[cooler][i];
          //   return sku;
          // })
          .filter((sku) => sku.shelf_number == shelf)
      );
    }
  }

  // getImages(cooler: string, dataArray: any) {
  //   let imageArray: any = []; // Initialize the cooler_images array
  //   // Iterate through each image URL
  //   const imagePromises = dataArray.map((data: any) =>
  //     this.apiService.fetchImageFromBlob(data.sku_image_uri).toPromise()
  //   ); // Convert observables to promises

  //   // Use Promise.all to wait for all requests to complete
  //   Promise.all(imagePromises)
  //     .then((responses: Blob[]) => {
  //       this.planogram_cooler_specific_sku_images[cooler] = responses.map(
  //         (res) => URL.createObjectURL(res)
  //       );
  //       console.log(
  //         'Images fetched and set:',
  //         this.planogram_cooler_specific_sku_images
  //       );
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching images:', error);
  //     });
  // }

  removeSku(sku: any, position: number, cooler: string, facings: number) {
    let temp_placed_sku_list = this.placed_sku_list[cooler].facings.slice(0);
    let shelf_data = this.placed_sku_list[cooler].shelves[sku.shelf_number - 1];
    let skuIndex =
      temp_placed_sku_list.findIndex(
        (s) => s.shelf_number == sku.shelf_number
      ) + position;
    let max_limit = sku.max_limit;
    let shelf_number = sku.shelf_number;
    let shelf_type = sku.shelf;
    // this.placed_sku_list[cooler].facings[skuIndex] = empty_sku_data
    let finaFacings =
      this.placed_sku_list[cooler].facings[skuIndex].final_facings;
    let final_facings_after_removed = finaFacings - 1;
    let empty_sku_data = {
      brand_inswa: '',
      category: '',
      cooler: cooler,
      diameter_mm: shelf_data.avg_diameter,
      final_facings: 0,
      height_mm: shelf_data.avg_height,
      max_limit: max_limit,
      mrp: 0,
      pack_size_revised: 0,
      pack_type_revised: '',
      placement_order: sku.placement_order,
      ranking: 0,
      sku_face: '',
      sku_image_uri: '',
      shelf_number: shelf_number,
      shelf: shelf_type,
      facings_multiplier: sku.facings_multiplier,
    };
    if (final_facings_after_removed == 0) {
      this.placed_sku_list[cooler].facings.splice(skuIndex, 1, empty_sku_data);
    } else {
      this.placed_sku_list[cooler].facings[skuIndex].final_facings =
        final_facings_after_removed;
      this.placed_sku_list[cooler].facings.splice(
        skuIndex + facings,
        0,
        empty_sku_data
      );
    }
  }

  addDropId(row_no: number, position: number, cooler: string) {
    let id =
      'placeholder_row_' + cooler + '_row_' + row_no + '_position_' + position;
    this.newDropItemIdEvent.emit({ id, row_no, position });
    return id;
  }

  downloadCoolerInfo(val: string): void {
    if (val === 'assortment') {
      let downloadData = this.review_lhs_sku_list['recommended'];
      this.downloadCSV(downloadData);
    } else {
      this.planogramState.generateImageAsPNG();
    }
  }

  downloadCSV(data: any) {
    const csvHeaders = ['PRODUCT ADDED', 'SHELVES', 'TOTAL FACINGS'];
    const csvRows = data.map((item: any) => [
      item.sku_face,
      item.shelf_type,
      item.total_final_facings,
    ]);

    let csvContent =
      'data:text/csv;charset=utf-8,' + csvHeaders.join(',') + '\n';
    csvRows.forEach((rowArray: any) => {
      let row = rowArray.join(',');
      csvContent += row + '\n';
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'Download_SKU.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  calculateSize(base: number, multiplier: number): string {
    return `${base * multiplier}px`;
  }

  getFooterImageStyle(caseType: CoolerType) {
    const multiplier = CONFIG.SIZE_MULTIPLIERS[caseType] || 1;

    return {
      'max-height': this.calculateSize(CONFIG.BASE_MAX_HEIGHT, multiplier),
      'max-width': this.calculateSize(CONFIG.BASE_MAX_WIDTH, multiplier),
      width: 'auto',
      height: 'auto',
      margin: 'auto',
      'object-fit': 'contain',
    };
  }
}
